import { PayloadAction, SerializedError, createSlice } from '@reduxjs/toolkit';

import { TEssenceGroups } from '@lib/core/characters/types/essences';
import { apiUrlGetEssenceGroup } from '@lib/core/essences/slices/urls';
import { createTypedAsyncThunk } from '@lib/core/service/createTypedAsyncThunk';
import { request } from '@lib/core/service/requests/request';

interface IEssenceGroupsSlice {
  isLoading: boolean;
  data: TEssenceGroups[];
  error: SerializedError;
}
const initialState: IEssenceGroupsSlice = {
  data: undefined,
  error: null,
  isLoading: false,
};

export const actionGetEssenceGroups = createTypedAsyncThunk('essences/groups/get', async () =>
  request({
    url: apiUrlGetEssenceGroup,
  }),
);

const essenceGroupsSlice = createSlice({
  extraReducers: builder => {
    builder.addCase(actionGetEssenceGroups.pending, state => {
      state.error = null;
      state.isLoading = true;
    });
    builder.addCase(actionGetEssenceGroups.fulfilled, (state, action: PayloadAction<TEssenceGroups[]>) => {
      const { payload } = action;
      state.isLoading = false;
      state.data = payload;
    });
    builder.addCase(actionGetEssenceGroups.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
  initialState,
  name: 'essenceGroups',
  reducers: {},
});

export default essenceGroupsSlice.reducer;
